var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 2C4.04669 2 3.73669 2 3.48236 2.06815C2.79218 2.25308 2.25309 2.79218 2.06815 3.48236C2 3.73669 2 4.04669 2 4.66667V11.3333C2 11.9533 2 12.2633 2.06815 12.5177C2.25308 13.2078 2.79218 13.7469 3.48236 13.9319C3.73669 14 4.04669 14 4.66667 14",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0007 11C11.0007 11 14.0006 8.79053 14.0006 8C14.0006 7.2094 11.0006 5 11.0006 5M13.334 8H5.33398",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLeave);
export default __webpack_public_path__ + "static/media/calendar_leave.670df14a1097e825667b40cad8edc6ad.svg";
export { ForwardRef as ReactComponent };